import { render, staticRenderFns } from "./createDoctor.vue?vue&type=template&id=958bc6c8&"
import script from "./createDoctor.vue?vue&type=script&lang=js&"
export * from "./createDoctor.vue?vue&type=script&lang=js&"
import style0 from "./createDoctor.vue?vue&type=style&index=0&id=958bc6c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports